const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Muhammad Zaid Ahmed | Portfolio",
  description:
    "A Data Science practitioner who thrives to leverage startups with AI based solutions with a blend of UI/UX",
  og: {
    title: "Zaid Portfolio",
    type: "website",
    url: "http://mzaidahmed.netlify.app/",
  },
};

//Home Page
const greeting = {
  title: "Hello!",
  sub: "Muhammad Zaid Ahmed",
  logo_name: "Muhammad Zaid Ahmed",
  resumeLink: "",
};

// home logos
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Github",
      iconifyClassname: "simple-icons:github",
      style: {
        color: "white",
      },
      profileLink: "https://github.com/mrzaid",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/m_zaidahmed861",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/",
    },
    {
      siteName: "LinkedIn",
      iconifyClassname: "simple-icons:linkedin",
      style: {
        color: "#0077b5",
      },
      profileLink: "https://www.linkedin.com/in/muhammadzaidahmed/",
    },
  ],
};

//what i do?
const skills = {
  data: [
    {
      title: "Data Science & Analysis",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Analyzed large datasets using statistical models and ML algorithms to identify patterns and trends",
        "⚡ Communicated findings to peers through exploratory data analysis, reports, and presentations.",
        "⚡ Having good hands-on with Data Cleaning, processing & Analysing using Pandas, Tableau & PowerBI",
        "⚡ Build predictive models to optimize results and other business metrics.",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "logos-numpy",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Tableau",
          fontAwesomeClassname: "logos-tableau",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
};

//project cards
// colors:[primary,secondary,success,danger,warning,info,light,dark,]
const projectcards = {
  list: [
    {
      title: "Sentiment Analysis on Movie Reviews",
      img_path: "project-001.jpg",
      description:
        "A WebApp to classify  movie reviews as positive or negative.",
      tags: [
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "seaborn",
          color: "#820032",
        },
        {
          lang: "SQL",
          color: "#00a100",
        },
        {
          lang: "Streamlit",
          color: "#ff4b4b",
        },
        {
          lang: "Heroku",
          color: "#3c0095",
        },
      ],
      link: "https://movie-review-classifier.onrender.com/ ",
      code: "https://github.com/",
      linkcolor: "white",
    },

    {
      title: "Automated Spam Email Detector",
      img_path: "project-06.png",
      description:
        "A streamlit webapp which works as a Automated Spam Email Detector",
      tags: [
        {
          lang: "ongoing",
          color: "red",
        },
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "matplotlib",
          color: "#c47206",
        },
        {
          lang: "seaborn",
          color: "#4257f5",
        },
        {
          lang: "Streamlit",
          color: "#ff4b4b",
        },
      ],
      link: "https://automated-spam-email-detector.onrender.com/",
      code: "",
      linkcolor: "white",
    },
    {
      title: "Olympics Large Dataset Analysis",
      img_path: "acti.gif",
      description:
        "A streamlit web app that provides detail analysis on 120 years of Olympic History",
      tags: [
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "matplotlib",
          color: "#c47206",
        },
        {
          lang: "Streamlit",
          color: "#ff4b4b",
        },
        {
          lang: "seaborn",
          color: "#3c0095",
        },
      ],
      link: "https://olympics-data-analysis-03vd.onrender.com/",
      code: "https://github.com/",
      linkcolor: "white",
    },
  ],
};

const resumeleft = {
  left: {
    title: ["Experience"],
    data: [
      {
        title: "Junior Software Engineer",
        subtitle: "Expedey",
        date: "Sept 2022 - Now",
        content: [
          "Working on integrating non-relational databases with Web apps via REST API’s.",
          "Integrating data from API’s to projects based on ReactJS and NextJS with server-side rendering.",
          "Using GraphQL to query data from headless CMS’s such as Contentful and Sanity.",
          "Using Redux Toolkit for overall state management of real-time data.",
        ],
      },
      {
        title: "Machine Learning Intern",
        subtitle: "National Centre for Artificial Intelligence",
        date: "Jan 2022 - April 2022",
        content: [
          "Analyzed large datasets using statistical models and ML algorithms to identify patterns and trends.",
          "Build predictive models to optimize results and other business metrics.",
          "Used SQL for querying, modifying and managing data stored in databases.",
        ],
      },
    ],
  },
};

const resumeright = {
  right: [
    {
      title: ["Education"],
      data: [
        {
          title: "Bachelor of Engineering in Mechanical",
          subtitle: "NED University of Engineering and Technology",
          date: "2018 - 2022",
          content: ["CGPA: 3.85/4"],
        },
        {
          title: "Higher Secondary Certificate [HSC]",
          subtitle: "Govt Dehli College",
          date: "2016 - 2018",
          content: ["Precentage: 88%"],
        },
      ],
    },
  ],
};

//certificate cards
const certifications = {
  certifications: [
    {
      title: "Problem solving",
      subtitle: "HackerRank",
      logo_path: "problem-01.png",
      certificate_link: "https://www.hackerrank.com/",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
    {
      title: "Python",
      subtitle: "HackerRank",
      logo_path: "python-01.png",
      certificate_link: "https://www.hackerrank.com/",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
    {
      title: "Machine Learning",
      subtitle: "Stanford University",
      logo_path: "coursera-01.png",
      certificate_link: "https://www.coursera.org/",
      alt_name: "Stanford University",
      color_code: "#000000",
    },
    {
      title: "Data Visualization",
      subtitle: "University of Michigan",
      logo_path: "coursera-01.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "University of Michigan",
      color_code: "#000000",
    },
    {
      title: "Data Scientist Career Track",
      subtitle: "DataCamp",
      logo_path: "datacamp-01.png",
      certificate_link: "https://www.datacamp.com/",
      alt_name: "DataCamp",
      color_code: "#000000",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contact.jpg",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours.",
  },
  addressSection: {
    title: "Address",
    subtitle: "House no#51-F Block#6 PECHS",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+92 3003387861",
  },
};

//contact icons
const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/mrzaid",
    iconifyClassname: "simple-icons:hackerrank",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/muhammadzaidahmed",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },

  {
    name: "Gmail",
    link: "mailto:m.zaidahmed861@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  projectsHeader,
  contactPageData,
  projectcards,
  certifications,
  resumeleft,
  resumeright,
};
